(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){const input=event.target;if(!input.matches('[data-vc-filter-group]'))return;document.querySelectorAll('[data-vc-filter-group]').forEach(function(peer){if(peer!==input&&peer.dataset.vcFilterGroup===input.dataset.vcFilterGroup)peer.checked=input.checked;});},true);
document.addEventListener('click',function(event){const link=event.target.closest('[data-vc-remove-param]');if(!link)return;event.preventDefault();event.stopImmediatePropagation();const url=new URL(location.href);const key=link.dataset.vcRemoveParam;const keep=url.searchParams.getAll(key).filter(value=>value.toLowerCase().replaceAll('assistance','assist')!==link.dataset.vcRemoveValue);url.searchParams.delete(key);keep.forEach(value=>url.searchParams.append(key,value));url.searchParams.delete('page');location.assign(url.href);},true);
  } catch(e) { console.error(e); }
})();

})();
